import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import getTranslationFile from '@ilteducation/localisation-vue3/src/language-loader';
import useLanguagesStore from '@/store/languages';
import config from '../config/ConfigProvider';

const useAreaTranslations = defineStore('area-translations', () => {
  const areaTranslations = ref<{ [areaId: string]: { [langCode: string]: { [section: string]: string } } }>({});
  const { supportedAreaGuideContentLanguages } = useLanguagesStore();
  const areaGuideLanguages = computed(() =>
    config.value('environment') === 'production' ? supportedAreaGuideContentLanguages : ['sv', 'en-gb', 'fi'],
  );

  const getAreaTranslation = async (areaId: string, langCode: string) => {
    if (areaTranslations.value[areaId] && areaTranslations.value[areaId][langCode]) {
      return langCode;
    }

    const translations = await getTranslationFile(config.value('guidesLokaliseProject'), langCode);
    if (!areaTranslations.value[areaId]) {
      areaTranslations.value[areaId] = {};
    }
    if (!translations[areaId]) {
      return undefined; // No translations yet for this area
    }
    areaTranslations.value[areaId][langCode] = translations[areaId];
    return langCode;
  };

  return { getAreaTranslation, areaTranslations, areaGuideLanguages };
});

export default useAreaTranslations;
